// extracted by mini-css-extract-plugin
module.exports = {"forecastItem":"ForecastItem_forecastItem__2SPFw","tempHighLow":"ForecastItem_tempHighLow__27heg"};